import LabelsProgressBar from "./LabelsProgressBar";
export default LabelsProgressBar;